<p-dialog
  header="お気に入り管理"
  [(visible)]="visible"
  [modal]="true"
  [style]="{ width: '500px' }">
  <div class="preset-save-section">
    <h4>現在の選択を保存</h4>
    <div class="flex align-items-center gap-2">
      <input
        pInputText
        [(ngModel)]="presetName"
        placeholder="お気に入り名を入力"
        class="flex-grow-1" />
      <button
        pButton
        (click)="save()"
        [disabled]="!canSave">
        <i
          class="pi pi-save"
          aria-hidden="true"></i>
        保存
      </button>
    </div>
    @if (isAtLimit) {
      <small class="p-error">お気に入りは最大5件までです</small>
    }
  </div>

  @if (presets.length > 0) {
    <div class="preset-list-section">
      <h4>保存済みお気に入り</h4>
      @for (preset of presets; track preset) {
        <div class="preset-item flex align-items-center justify-content-between gap-2">
          <span class="preset-name">{{ preset.name }}</span>
          <div class="flex gap-1">
            <button
              pButton
              class="p-button-sm p-button-success"
              (click)="load(preset)">
              <i
                class="pi pi-upload"
                aria-hidden="true"></i>
              呼び出し
            </button>
            <button
              pButton
              iconOnly
              class="p-button-sm p-button-danger p-button-outlined"
              (click)="delete(preset.id)">
              <i
                class="pi pi-trash"
                aria-hidden="true"></i>
            </button>
          </div>
        </div>
      }
    </div>
  }

  @if (presets.length === 0) {
    <div class="preset-empty">
      <p>保存済みお気に入りはありません</p>
    </div>
  }
</p-dialog>
